import { dyzioEngagementScore } from './helper-functions';
import { YOUTUBE_WATCH_URL } from './static-configuration';

export const formatYoutubeVideoAnalytics = (data) => {
  const trackedAssetAnalytics = {};
  const stats = data.statistics.slice(-1)[0];
  const engagementScore = dyzioEngagementScore(stats.likeCount, stats.dislikeCount, stats.commentCount, stats.viewCount);

  trackedAssetAnalytics.likes = stats.likeCount;
  trackedAssetAnalytics.dislikes = stats.dislikeCount;
  trackedAssetAnalytics.comments = stats.commentCount;
  trackedAssetAnalytics.views = stats.viewCount;
  trackedAssetAnalytics.engagementScore = engagementScore;
  trackedAssetAnalytics.publishedDate = data.publishedDate;
  trackedAssetAnalytics.title = data.title || '';
  trackedAssetAnalytics.channelTitle = data.channelTitle;
  trackedAssetAnalytics.influencerName = data.influencerName;
  trackedAssetAnalytics.thumbnail = data.thumbnail;
  trackedAssetAnalytics.videoUrl = `${YOUTUBE_WATCH_URL}${data.youtubeVideoId}`;
  trackedAssetAnalytics.statistics = data.statistics;
  trackedAssetAnalytics.isVideo = true;
  trackedAssetAnalytics.platformId = data.channelId;
  trackedAssetAnalytics.copy = data.description || '';

  return trackedAssetAnalytics;
};

export const formatInstagramAnalytics = (data) => {
  const trackedAssetAnalytics = {};
  if (!data || !data.latestStatistic || !data.latestStatistic.followerCount) return null;
  if (data.isVideo && !data.latestStatistic.viewCount) return null;

  trackedAssetAnalytics.likes = data.latestStatistic.likeCount;
  trackedAssetAnalytics.comments = data.latestStatistic.commentCount;
  trackedAssetAnalytics.followers = data.latestStatistic.followerCount;
  if (data.isVideo) trackedAssetAnalytics.views = data.latestStatistic.viewCount;
  trackedAssetAnalytics.engagementScore = dyzioEngagementScore(trackedAssetAnalytics.likes, 0, trackedAssetAnalytics.comments, trackedAssetAnalytics.followers);
  trackedAssetAnalytics.publishedDate = data.publishedDate;
  trackedAssetAnalytics.title = data.text || '';
  trackedAssetAnalytics.thumbnail = data.thumbnail;
  trackedAssetAnalytics.channelTitle = data.instagramHandle;
  trackedAssetAnalytics.influencerName = data.influencerName;
  trackedAssetAnalytics.videoUrl = data.videoUrl;
  trackedAssetAnalytics.isVideo = data.isVideo;
  trackedAssetAnalytics.platformId = data.instagramHandle;
  trackedAssetAnalytics.copy = data.text || '';

  return trackedAssetAnalytics;
};

export const formatFacebookAnalytics = (data) => {
  const trackedAssetAnalytics = {};
  if (!data || !data.latestStatistic) return null;

  trackedAssetAnalytics.likes = data.latestStatistic.likeCount;
  trackedAssetAnalytics.reactions = data.latestStatistic.reactionCount;
  trackedAssetAnalytics.comments = data.latestStatistic.commentCount;
  trackedAssetAnalytics.views = data.latestStatistic.viewCount;
  trackedAssetAnalytics.shares = data.latestStatistic.shareCount;
  trackedAssetAnalytics.publishedDate = data.createdDate;
  trackedAssetAnalytics.title = data.text || '';
  trackedAssetAnalytics.thumbnail = `https://graph.facebook.com/${data.facebookId}/picture`;
  trackedAssetAnalytics.videoUrl = data.videoUrl;
  trackedAssetAnalytics.channelTitle = data.influencerName;
  trackedAssetAnalytics.influencerName = data.influencerName;
  trackedAssetAnalytics.isVideo = data.isVideo;
  trackedAssetAnalytics.videoUrl = data.signedVideoUrl;
  trackedAssetAnalytics.platformId = data.facebookHandle;
  trackedAssetAnalytics.copy = data.text || '';

  /* TODO Add remaining
  trackedAssetAnalytics.followers = data.latestStatistic.followerCount;
  if (data.isVideo) trackedAssetAnalytics.views = data.latestStatistic.viewCount;
  trackedAssetAnalytics.engagementScore = dyzioEngagementScore(trackedAssetAnalytics.likes, 0, trackedAssetAnalytics.comments, trackedAssetAnalytics.followers);
  */

  return trackedAssetAnalytics;
};

export const formatTwitterAnalytics = data => {
  const trackedAssetAnalytics = {};
  if (!data) return null;

  const ls = data.latestStatistic;

  if (ls) {
    trackedAssetAnalytics.likes = ls.likeCount;
    trackedAssetAnalytics.retweets = ls.retweetCount;
    trackedAssetAnalytics.reach = ls.followerCount;
  }

  trackedAssetAnalytics.tweetId = data.tweetId;
  trackedAssetAnalytics.title = data.text;
  trackedAssetAnalytics.channelTitle = data.twitterHandle;

  trackedAssetAnalytics.influencerName = data.twitterHandle;

  return trackedAssetAnalytics;
};



/** WEBPACK FOOTER **
 ** ./src/utils/tracked-asset-helpers.js
 **/